import { useEffect, useState } from "react";
import { BadgeCheck, LogIn } from "lucide-react";
import { useCustomer } from "@/context/CustomerContext";

const KEY = "uplink_contact";
const input = "w-full px-3 py-2.5 rounded-lg border border-ink/20 bg-white/60 text-sm focus:outline-none focus:ring-2 focus:ring-forest/30";

export const loadContact = () => {
  try { return { name: "", whatsapp: "", promo_consent: false, ...JSON.parse(localStorage.getItem(KEY) || "{}") }; } catch { return { name: "", whatsapp: "", promo_consent: false }; }
};

export const useContact = () => {
  const { customer } = useCustomer();
  const [c, setC] = useState(loadContact);
  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(c)); }, [c]);
  useEffect(() => {
    if (customer && !c.name) setC((x) => ({ ...x, name: customer.name || "" }));
    if (customer?.whatsapp && !c.whatsapp) setC((x) => ({ ...x, whatsapp: customer.whatsapp.replace(/^62/, "0") }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customer]);
  return [c, setC];
};

export const ContactFields = ({ contact, setContact }) => {
  const set = (k) => (e) => setContact((x) => ({ ...x, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value }));
  return (
    <div className="py-3 border-t border-sage-200 space-y-2.5" data-testid="checkout-contact">
      <div className="text-sm font-semibold">Data pemesan</div>
      <input value={contact.name} onChange={set("name")} maxLength={60} placeholder="Nama kamu" className={input} data-testid="checkout-name-input" />
      <input value={contact.whatsapp} onChange={set("whatsapp")} maxLength={20} inputMode="tel" placeholder="Nomor WhatsApp, mis. 0812xxxxxxxx" className={input} data-testid="checkout-whatsapp-input" />
      <label className="flex items-start gap-2 text-xs text-muted2 cursor-pointer">
        <input type="checkbox" checked={contact.promo_consent} onChange={set("promo_consent")} className="mt-0.5 accent-[#155EAD]" data-testid="checkout-promo-consent" />
        <span>Saya bersedia menerima info promo UPLINK COFFEE lewat WhatsApp/email.</span>
      </label>
    </div>
  );
};

export const MemberNotice = () => {
  const { customer, login } = useCustomer();
  if (customer === null) return null;
  if (customer) {
    return (
      <div className="mt-4 flex items-center gap-2 rounded-xl bg-paper border border-sage-200 px-4 py-3 text-sm" data-testid="member-active-notice">
        <BadgeCheck className="w-5 h-5 text-forest shrink-0" /> Kamu member. Pesanan ini menambah Coin membership.
      </div>
    );
  }
  return (
    <div className="mt-4 rounded-xl bg-amber-50 border border-amber-200 px-4 py-3 text-sm text-amber-900" data-testid="member-warning">
      <b>Mau jadi member & dapat Coin?</b> Wajib masuk dengan Gmail. Tanpa masuk, kamu tetap bisa memesan sebagai tamu, tapi tidak mendapat Coin.
      <button onClick={login} className="mt-2.5 w-full py-2.5 rounded-lg bg-white border border-amber-300 font-semibold flex items-center justify-center gap-2 hover:bg-amber-100 transition-colors" data-testid="member-login-button">
        <LogIn className="w-4 h-4" /> Masuk dengan Gmail
      </button>
    </div>
  );
};
